import { createPageDefinition } from 'ui-page-helpers/src/createPageDefinition';
import Component from './component';

export default createPageDefinition({
  component: Component,
  title: 'Parent Connect/Landing Widget',
  exportTitle: 'parentConnectLandingWidget',
  selectorClass: 'parent-connect-landing-widget',
})